import { isCasual } from './racquetScoreDomain.mjs'

// Presentation only. Never changes official winner, closure or sportingCompletion.
// Empty trailing editor rows are not play; genuine unfinished points are.
export function racquetOutcome(state) {
  const racket = ['tennis', 'padel'].includes(state.rules.sport)
  const stopped = state.stoppedSegment
  const unfinished =
    (stopped?.score || (racket ? state.games : state.points)).some(Boolean) ||
    (racket && (stopped?.points || state.points).some(Boolean))
  const wins = [0, 0]
  for (const segment of state.segments) {
    const [a, b] = segment.score
    if (a !== b) wins[a > b ? 0 : 1]++
  }
  const casual = isCasual(state)
  const winner = casual
    ? state.status === 'session_saved' && !unfinished && wins[0] !== wins[1]
      ? state.teams[wins[0] > wins[1] ? 0 : 1].id
      : null
    : state.status === 'completed'
      ? state.winner
      : null
  const kind =
    !casual || state.status !== 'session_saved'
      ? state.status
      : winner
        ? 'sessionWinner'
        : unfinished
          ? 'playEndedEarly'
          : state.segments.length
            ? racket
              ? 'levelOnSets'
              : 'levelOnGames'
            : 'sessionSaved'
  return {
    kind,
    winner,
    wins,
    unfinished,
    unit: racket ? 'sets' : 'games',
    official: !casual && state.status === 'completed'
  }
}
